// extracted by mini-css-extract-plugin
export default {"panels":"projects_panels__K3AqJ","link":"projects_link__3gS+E","panel":"projects_panel__qeJoH","stats":"projects_stats__j7+T1","statsInfo":"projects_statsInfo__wnZcc"};